import { classNames } from 'libs/react';
import { useQuery } from 'libs/react';
import { SaleItemGroupsQuery } from 'graphql/SaleItemGroup/queries/SaleItemGroupsQuery';
import { React } from 'libs/react';
import { FormMultiSelect } from 'components/form/FormMultiSelect';
import './FormSaleItemGroup.scss';
/**
 * @component FormSaleItemGroup
 * @since 1.0.0
 */
export function FormSaleItemGroup(props) {
    var _a;
    const { style } = Object.assign({ style: 'normal' }, props);
    const [data] = useQuery(SaleItemGroupsQuery, {
        variables: {
            input: {
                entity: props.entity
            }
        }
    });
    const options = (_a = data === null || data === void 0 ? void 0 : data.saleItemGroups.map((group) => ({
        value: group.id,
        label: group.title
    }))) !== null && _a !== void 0 ? _a : [];
    // order by title
    options.sort((a, b) => a.label.localeCompare(b.label));
    const className = classNames('form-sale-item-group', 'form-sale-item-group--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-sale-item-group-field" },
            React.createElement(FormMultiSelect, Object.assign({}, props, { options: options })))));
}
